import storage from '@/commons/storage'
import themes from '@/commons/themes';

const state = {
  themeColor: storage.get('themeColor') || themes.theme_colors[0], //主题的颜色
  naviColors: storage.get('naviColors') || themes.navi_colors[0], //导航栏颜色
  naviActive: storage.get('naviActive') && true, //导航栏折叠
  naviLocate: storage.get('naviLocate') || 'top',
  tabsActive: storage.get('tabsActive') || false, //有无标签栏
  setsActive: false, //设置栏折叠
}

/** 同步存值 通过 commit 来调用 */
const mutations = {
  themeColor: (st, themeColor) => {
    st.themeColor = themeColor;
  },
  naviColors: (st, naviColors) => {
    st.naviColors = naviColors;
  },
  naviActive: (st, naviActive) => {
    st.naviActive = naviActive;
  },
  naviLocate: (st, naviLocate) => {
    st.naviLocate = naviLocate;
  },
  setsActive: (st, setsActive) => {
    st.setsActive = setsActive;
  },
  tabsActive: (st, tabsActive) => {
    st.tabsActive = tabsActive;
  }
}

/** 异步存值 通过 dispatch 来调用 */
const actions = {
  themeColor({ commit }, themeColor) {
    storage.set("themeColor", themeColor);
    commit('themeColor', themeColor);
  },
  naviColors({ commit }, naviColors) {
    storage.set("naviColors", naviColors);
    commit('naviColors', naviColors);
  },
  naviActive({ commit }, naviActive) {
    storage.set("naviActive", naviActive);
    commit('naviActive', naviActive);
  },
  naviLocate({ commit }, naviLocate) {
    storage.set("naviLocate", naviLocate);
    commit('naviLocate', naviLocate);
  },
  tabsActive({ commit }, tabsActive) {
    storage.set("tabsActive", tabsActive);
    commit('tabsActive', tabsActive);
  },
  setsActive({ commit }, setsActive) {
    commit('setsActive', setsActive);
  },
}

/** 同步取值 通过 getters 来调用 */
const getters = {
  themeColor: st => st.themeColor,
  naviColors: st => st.naviColors,
  naviActive: st => st.naviActive,
  naviLocate: st => st.naviLocate,
  setsActive: st => st.setsActive,
  tabsActive: st => st.tabsActive,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
